import { Component, Prop, Watch, Vue } from "vue-property-decorator";

import OverlayLoader from "../overlayLoader/overlayLoader";

@Component({
  components: {
    OverlayLoader,
  },
})
export default class ModalBase extends Vue {
  @Prop({ default: false }) isActive!: Boolean;
  @Prop({ default: "xsmall" }) size!: String;
  @Prop({ default: "20px 15px" }) padding!: String;
  @Prop({ default: true }) isBtnClose!: Boolean;
  @Prop({ default: true }) isOverleyClose!: Boolean;
  @Prop({ default: false }) isLoading!: Boolean;
  @Prop({ default: "Guardar" }) mainButtonLabel: string;
  @Prop({ default: "Cancelar" }) secondaryButtonLabel: string;
  @Prop({ default: "$titulo" }) title: string;
  @Prop({ default: false }) isMainButtonDisabled;
  @Prop({ default: "main-button" }) mainButtonType;
  @Prop({ default: true }) isHeader;

  @Watch("isActive")
  onIsActive(val) {
    val ? this.$emit("show") : this.$emit("hide");
  }

  _modalClose(type = "") {
    if (!type || (type === "overley" && this.isOverleyClose)) {
      this.$emit("modal-close");
    }
  }

  onSave() {
    if (!this.isMainButtonDisabled) this.$emit("on-save");
  }
}
